/* GLOVARA · rotation 360° en vidéo (10 oct 2026, soir ; idée d'Ala ; mis en place par theme-sangle-nl_soir-10oct.py).
   Remplace, pour la section glv-rotation, assets/glv-rotation.js (60 images dessinées au défilement, environ 2,2 Mo),
   qui reste dans le thème avec ses 60 images : rien n'est supprimé.
   - La sangle tourne seule, en boucle, sans son : vidéo MP4 de 4 s par tour (glv-rotation-720.mp4, 0,16 Mo, ou
     glv-rotation-900.mp4, 0,26 Mo), choisie selon la largeur affichée (au-delà de 800 pixels réels : 900 px).
   - Rien n'est téléchargé avant l'approche de la section (1 500 px) : à ce moment, l'image d'attente (14 Ko) et la
     vidéo. Lecture quand un quart de la vidéo est à l'écran, pause quand elle en sort.
   - Mouvement réduit (réglage du téléphone) : image fixe seulement, textes visibles (CSS, comme avant).
   - Lecture automatique refusée (mode économie d'énergie sur iPhone) : l'image fixe reste, sans commandes.
   - Les 3 points et le bouton apparaissent au défilement EXACTEMENT comme avant (même calcul que glv-rotation.js). */
(function () {
  function init(racine) {
    if (racine.getAttribute("data-glv-rot-pret")) return;
    racine.setAttribute("data-glv-rot-pret", "1");
    var video = racine.querySelector("video[data-glv-rot-video]");
    var points = [].slice.call(racine.querySelectorAll(".glv-rot__point"));
    var bouton = racine.querySelector(".glv-rot__bouton");
    var enAttente = false, prete = false;
    var calme = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // ---- la vidéo
    function preparer() {
      if (prete || !video) return;
      prete = true;
      var affiche = video.getAttribute("data-glv-poster");
      if (affiche && !video.getAttribute("poster")) video.setAttribute("poster", affiche);
      if (calme) return;
      var scene = video.parentNode;
      var large = (scene && scene.clientWidth) || video.clientWidth || 0;
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var src = video.getAttribute(large * dpr > 800 ? "data-src-900" : "data-src-720");
      if (!src) return;
      video.muted = true;
      video.setAttribute("preload", "auto");
      video.src = src;
    }
    function jouer() {
      if (!video || calme) return;
      preparer();
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* lecture refusée ou interrompue : l'image fixe reste */ });
    }
    if (video) {
      if ("IntersectionObserver" in window) {
        new IntersectionObserver(function (e, o) {
          if (e[0].isIntersecting) { preparer(); o.disconnect(); }
        }, { rootMargin: "1500px 0px" }).observe(racine);
        new IntersectionObserver(function (e) {
          var x = e[0];
          if (x.isIntersecting && x.intersectionRatio >= 0.25) jouer();
          else if (!video.paused) video.pause();
        }, { threshold: [0, 0.25] }).observe(video);
      } else {
        preparer();
        jouer();
      }
    }

    if (calme) return;   // mouvement réduit : textes et bouton visibles par le CSS, pas d'animation

    // ---- les textes : même calcul que glv-rotation.js (2 oct 2026, retours d'Ala sur iPhone)
    var collant = racine.querySelector(".glv-rot__collant"), colle = false;
    function avancement() {
      var r = racine.getBoundingClientRect(), vh = window.innerHeight;
      colle = !!collant && window.getComputedStyle(collant).position === "sticky";
      var total = colle ? r.height : r.height + vh * 0.75;
      return total > 0 ? Math.min(1, Math.max(0, (vh - r.top) / total)) : 0;
    }
    var entete = document.querySelector("sticky-header, .header-wrapper, .shopify-section-header-sticky, .entete");
    function mesurerEntete() {
      var h = entete ? Math.round(entete.getBoundingClientRect().height) : 0;
      racine.style.setProperty("--glv-haut", Math.min(Math.max(h, 0), 140) + "px");
    }
    var bornes = function (v) { return Math.min(1, Math.max(0, v)); };
    function visible(el) {
      var vh = window.innerHeight, haut = el.parentNode.getBoundingClientRect().top + el.offsetTop;
      return bornes((vh * 0.94 - haut) / (vh * 0.12));
    }
    function maj() {
      enAttente = false;
      var p = avancement();
      var debutBouton = colle ? 0.9 : 0.72;
      var avant = 1;
      points.forEach(function (el, k) {
        var v = Math.min(visible(el), bornes((p - (0.22 + k * 0.07)) / 0.06), avant > 0.6 ? 1 : 0);
        el.style.setProperty("--v", v.toFixed(3)); avant = v;
      });
      // 11 oct 2026, 0 h 30 (Ala) : sur téléphone, la section n'est plus collée à l'écran (plus de vide sous le bouton) ;
      // le bouton apparaît dès qu'il arrive à l'écran, après le 3e point
      var pBouton = (!colle && window.innerWidth < 990) ? 1 : bornes((p - debutBouton) / 0.07);
      if (bouton) bouton.style.setProperty("--v", Math.min(colle ? 1 : visible(bouton.parentNode), pBouton, avant > 0.6 ? 1 : 0).toFixed(3));
    }
    function auDefilement() { if (!enAttente) { enAttente = true; window.requestAnimationFrame(maj); } }
    window.addEventListener("scroll", auDefilement, { passive: true });
    window.addEventListener("resize", function () { mesurerEntete(); auDefilement(); });
    mesurerEntete();
    maj();
  }
  function demarrer() { [].forEach.call(document.querySelectorAll(".glv-rot"), init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", demarrer); else demarrer();
})();
